import { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap, Circle } from 'react-leaflet';
import L from 'leaflet';
import useLiveTracking from '../../hooks/useLiveTracking';

// Fix for default markers
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});
// import useInspectorTracking from '../../hooks/useInspectorTracking';

// Inspector person icon
// const inspectorIconSvg = `
// <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
//   <defs>
//     <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
//       <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.3)"/>
//     </filter>
//   </defs>
//   <circle cx="20" cy="20" r="18" fill="#10B981" stroke="white" stroke-width="2" style="filter:url(#shadow);"/>
//   <path d="M20 8C17.8 8 16 9.8 16 12C16 14.2 17.8 16 20 16C22.2 16 24 14.2 24 12C24 9.8 22.2 8 20 8Z" fill="white"/>
//   <path d="M12 28C12 23.6 15.6 20 20 20C24.4 20 28 23.6 28 28V30C28 31.1 27.1 32 26 32H14C12.9 32 12 31.1 12 30V28Z" fill="white"/>
// </svg>
// `;

// const inspectorOfflineIconSvg = `
// <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
//   <defs>
//     <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
//       <feDropShadow dx="0" dy="2" stdDeviation="2" flood-color="rgba(0,0,0,0.3)"/>
//     </filter>
//   </defs>
//   <circle cx="20" cy="20" r="18" fill="#6B7280" stroke="white" stroke-width="2" style="filter:url(#shadow);"/>
//   <path d="M20 8C17.8 8 16 9.8 16 12C16 14.2 17.8 16 20 16C22.2 16 24 14.2 24 12C24 9.8 22.2 8 20 8Z" fill="white"/>
//   <path d="M12 28C12 23.6 15.6 20 20 20C24.4 20 28 23.6 28 28V30C28 31.1 27.1 32 26 32H14C12.9 32 12 31.1 12 30V28Z" fill="white"/>
// </svg>
// `;

const userLocationSvg = `
<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="15" cy="15" r="13" fill="#3B82F6" stroke="white" stroke-width="2"/>
  <circle cx="15" cy="15" r="6" fill="white"/>
</svg>
`;

// Custom building icon
const iconSvg = `
<svg width="46" height="46" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter id="shadow-sm" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="2" stdDeviation="1.5" flood-color="rgba(0,0,0,0.3)"/>
    </filter>
  </defs>
  <path d="M18 0C10.8 0 5 5.8 5 13C5 22.8 18 36 18 36C18 36 31 22.8 31 13C31 5.8 25.2 0 18 0Z" fill="#4F46E5" style="filter:url(#shadow-sm);"/>
  <circle cx="18" cy="13" r="9" fill="white" fill-opacity="0.15"/>
  <path d="M13 20H23V12L18 9L13 12V20Z" fill="white"/>
  <rect x="15" y="14" width="2" height="2" rx="0.5" fill="#4F46E5"/>
  <rect x="19" y="14" width="2" height="2" rx="0.5" fill="#4F46E5"/>
  <rect x="15" y="17" width="2" height="2" rx="0.5" fill="#4F46E5"/>
  <rect x="19" y="17" width="2" height="2" rx="0.5" fill="#4F46E5"/>
</svg>
`;

const selectedIconSvg = `
<svg width="56" height="56" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <defs>
    <filter id="shadow-lg" x="-50%" y="-50%" width="200%" height="200%">
      <feDropShadow dx="0" dy="4" stdDeviation="3" flood-color="rgba(0,0,0,0.4)"/>
    </filter>
    <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
      <stop offset="0%" style="stop-color:#F43F5E;stop-opacity:1" />
      <stop offset="100%" style="stop-color:#E11D48;stop-opacity:1" />
    </linearGradient>
  </defs>
  <path d="M18 0C10.8 0 5 5.8 5 13C5 22.8 18 36 18 36C18 36 31 22.8 31 13C31 5.8 25.2 0 18 0Z" fill="url(#grad1)" style="filter:url(#shadow-lg);"/>
  <path d="M18 0C10.8 0 5 5.8 5 13C5 22.8 18 36 18 36C18 36 31 22.8 31 13C31 5.8 25.2 0 18 0Z" stroke="white" stroke-width="1.5" stroke-opacity="0.5"/>
  <circle cx="18" cy="13" r="9" fill="white" fill-opacity="0.2"/>
  <path d="M13 20H23V12L18 9L13 12V20Z" fill="white"/>
  <rect x="15" y="14" width="2" height="2" rx="0.5" fill="#E11D48"/>
  <rect x="19" y="14" width="2" height="2" rx="0.5" fill="#E11D48"/>
  <rect x="15" y="17" width="2" height="2" rx="0.5" fill="#E11D48"/>
  <rect x="19" y="17" width="2" height="2" rx="0.5" fill="#E11D48"/>
</svg>
`;

// const inspectorIcon = new L.DivIcon({
//   html: inspectorIconSvg,
//   className: 'bg-transparent',
//   iconSize: [40, 40],
//   iconAnchor: [20, 20],
//   popupAnchor: [0, -20]
// });

// const inspectorOfflineIcon = new L.DivIcon({
//   html: inspectorOfflineIconSvg,
//   className: 'bg-transparent',
//   iconSize: [40, 40],
//   iconAnchor: [20, 20],
//   popupAnchor: [0, -20]
// });



const userLocationIcon = new L.DivIcon({
  html: userLocationSvg,
  className: 'bg-transparent',
  iconSize: [30, 30],
  iconAnchor: [15, 15],
  popupAnchor: [0, -15]
});

const customIcon = new L.DivIcon({
  html: iconSvg,
  className: 'bg-transparent',
  iconSize: [46, 46],
  iconAnchor: [23, 46],
  popupAnchor: [0, -46]
});

const customSelectedIcon = new L.DivIcon({
  html: selectedIconSvg,
  className: 'bg-transparent',
  iconSize: [56, 56],
  iconAnchor: [28, 56],
  popupAnchor: [0, -56]
});

const MapController = ({ selectedProperty, properties }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    // 🔹 CASE 1: Selected property → zoom in
    if (
      selectedProperty &&
      selectedProperty.latitude &&
      selectedProperty.longitude
    ) {
      const lat = parseFloat(selectedProperty.latitude);
      const lng = parseFloat(selectedProperty.longitude);

      if (!isNaN(lat) && !isNaN(lng)) {
        map.flyTo([lat, lng], 16, {
          duration: 1.5,
        });
      }
      return;
    }

    // 🔹 CASE 2: No selection → zoom out to all pins
    const validProperties = properties.filter(p => {
      const lat = parseFloat(p.latitude);
      const lng = parseFloat(p.longitude);
      return !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
    });

    if (validProperties.length === 0) return;

    const bounds = L.latLngBounds(
      validProperties.map(p => [
        parseFloat(p.latitude),
        parseFloat(p.longitude),
      ])
    );

    map.fitBounds(bounds, {
      padding: [60, 60],
      maxZoom: 7, // 👈 prevents over-zoom when pins are close
      animate: true,
    });
  }, [map, selectedProperty, properties]); // ✅ FULL dependency

  return null;
};


const PropertyMap = ({ properties, onSelectProperty, selectedPropertyId }) => {
  const [center] = useState([51.5074, -0.1278]);
  const selectedProperty = properties?.find(p => p.propertyMasterId === selectedPropertyId);
  const { userLocation } = useLiveTracking();
function ResizeFix() {
  const map = useMap();

  useEffect(() => {
    setTimeout(() => {
      map.invalidateSize();
    }, 100);
  }, [map]);

  return null;
}
  return (
    <div className="h-100 w-100" style={{ position: 'relative', zIndex: 0, minHeight: '400px' }}>
      {/* Live Tracking Controls */}
      {/* <div className="position-absolute top-0 end-0 m-3" style={{ zIndex: 1000 }}>
        <div className="bg-white rounded shadow p-2">
          <div className="d-flex flex-column gap-2">
            <button 
              onClick={getCurrentLocation}
              className="btn btn-outline-primary btn-sm"
            >
              <i className="fas fa-location-arrow me-1"></i>
              My Location
            </button>
            <button 
              onClick={isTracking ? stopTracking : startTracking}
              className={`btn btn-sm ${isTracking ? 'btn-danger' : 'btn-success'}`}
            >
              <i className={`fas ${isTracking ? 'fa-stop' : 'fa-play'} me-1`}></i>
              {isTracking ? 'Stop' : 'Track'}
            </button>
          </div>
          {inspectors.length > 0 && (
            <div className="mt-2 pt-2 border-top">
              <small className="text-muted d-block mb-1">Inspectors: {inspectors.length}</small>
              {inspectors.map(inspector => (
                <div key={inspector.id} className="d-flex align-items-center gap-1 mb-1">
                  <div className={`rounded-circle ${inspector.status === 'active' ? 'bg-success' : 'bg-secondary'}`} style={{ width: '8px', height: '8px' }}></div>
                  <small className="text-muted">{inspector.name}</small>
                </div>
              ))}
            </div>
          )}
        </div>
      </div> */}
      <MapContainer 
        center={center} 
        zoom={12} 
        style={{ height: '100%', width: '100%' }}
       
      >
        <ResizeFix />
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {/* Property Markers */}
        {properties
          .filter(property => {
            const lat = parseFloat(property.latitude);
            const lng = parseFloat(property.longitude);
            return !isNaN(lat) && !isNaN(lng) && lat !== 0 && lng !== 0;
          })
          .map((property) => {
            const lat = parseFloat(property.latitude);
            const lng = parseFloat(property.longitude);
            return (
              <Marker
                key={property.propertyMasterId}
                position={[lat, lng]}
                icon={property.propertyMasterId === selectedPropertyId ? customSelectedIcon : customIcon}
                eventHandlers={{
                  click: () => onSelectProperty(property),
                }}
              >
                <Popup className="min-w-200">
                  <div className="d-flex flex-column gap-2">
                    <h5 className="fw-bold mb-0">{property.name}</h5>
                    <div className="property-meta">
																				{property.address && (
																					<span className="property-address">
																						<i className="fas fa-map-marker-alt"></i>
																						{property.address}
																					</span>
																				)}
																			</div>
                    {/* {property.address && (
                      <p className="text-muted small mb-1">{property.address}</p>
                    )} */}
                    {/* <button
                      onClick={() => onSelectProperty(property)}
                      className="btn btn-primary btn-sm"
                    >
                      View Details
                    </button> */}
                  </div>
                </Popup>
              </Marker>
            );
          })}

        {/* User Location */}
        {userLocation && (
          <>
            <Marker
              position={[userLocation.latitude, userLocation.longitude]}
              icon={userLocationIcon}
            >
              <Popup>
                <div className="text-center">
                  <h6 className="mb-1">Your Location</h6>
                  <small className="text-muted">
                    Accuracy: ±{Math.round(userLocation.accuracy)}m
                  </small>
                </div>
              </Popup>
            </Marker>
            <Circle
              center={[userLocation.latitude, userLocation.longitude]}
              radius={userLocation.accuracy}
              pathOptions={{ color: '#3B82F6', fillColor: '#3B82F6', fillOpacity: 0.1 }}
            />
          </>
        )}

        {/* Inspector Locations */}
        {/* {inspectors.map((inspector) => (
          <Marker
            key={inspector.id}
            position={[inspector.latitude, inspector.longitude]}
            icon={inspector.status === 'active' ? inspectorIcon : inspectorOfflineIcon}
          >
            <Popup>
              <div className="text-start" style={{ minWidth: '200px' }}>
                <div className="d-flex align-items-center gap-2 mb-2">
                  <div className={`rounded-circle ${inspector.status === 'active' ? 'bg-success' : 'bg-secondary'}`} style={{ width: '10px', height: '10px' }}></div>
                  <h6 className="mb-0">{inspector.name}</h6>
                </div>
                <div className="mb-2">
                  <small className="text-muted d-block"><i className="fas fa-envelope me-1"></i>{inspector.email}</small>
                  <small className="text-muted d-block"><i className="fas fa-phone me-1"></i>{inspector.phone}</small>
                </div>
                {inspector.currentProperty && (
                  <div className="mb-2">
                    <small className="text-muted"><i className="fas fa-building me-1"></i>At: {inspector.currentProperty}</small>
                  </div>
                )}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <small className="text-muted">
                    <i className={`fas fa-battery-${inspector.batteryLevel > 75 ? 'full' : inspector.batteryLevel > 50 ? 'three-quarters' : inspector.batteryLevel > 25 ? 'half' : 'quarter'} me-1`}></i>
                    {inspector.batteryLevel}%
                  </small>
                  <small className="text-muted">
                    {new Date(inspector.lastUpdate).toLocaleTimeString()}
                  </small>
                </div>
                <div className="text-center">
                  <span className={`badge ${inspector.status === 'active' ? 'bg-success' : 'bg-secondary'}`}>
                    {inspector.status === 'active' ? 'Online' : 'Offline'}
                  </span>
                </div>
              </div>
            </Popup>
          </Marker>
        ))} */}

        <MapController selectedProperty={selectedProperty} properties={properties} />
      </MapContainer>
    </div>
  );
};

export default PropertyMap;